import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SectionHeader from '../../pages/components/SectionHeader';

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  //margin-bottom: ${props =>
    props.noMargin ? 0 : props.breakpoint !== 'phone' ? 14.375 : 3}rem;
  margin-bottom: ${props =>
    props.noMargin ? 0 : props.breakpoint !== 'phone' ? 10.125 : 3}rem;
`;

const ContentSection = props => {
  const { children, className, title, ...rest } = props;
  return (
    <StyledSection className={className} {...rest}>
      {title && <SectionHeader title={title} />}
      {children}
    </StyledSection>
  );
};

ContentSection.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  className: PropTypes.string,
  title: PropTypes.string,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps)(ContentSection);



// WEBPACK FOOTER //
// ./src/modules/layout/components/ContentSection.js